import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { getRecruitmentQueryKey, usePostRecruitmentCreate } from '@/shared/api'
import { getErrorMessage, PAGE_SIZE } from '@/shared/model'

export const useRecruitmentCreate = () => {
    const queryClient = useQueryClient()

    const { mutateAsync } = usePostRecruitmentCreate({
        mutation: {
            onSuccess: async (data) => {
                await queryClient.invalidateQueries({
                    queryKey: getRecruitmentQueryKey({
                        limit: PAGE_SIZE,
                        offset: 0,
                    }),
                })

                if (data.is_approved) {
                    toast.success('Уведомление о вербовке отправлено водителю')
                } else {
                    toast.success('Заявка на регистрацию водителя создана')
                }
            },
            onError: (error) => {
                toast.error(getErrorMessage(error.error_code))
            },
        },
    })

    return {
        createRecruitment: mutateAsync,
    }
}
